<div class="cvds-photos" [ngClass]="{'completely-wide': width100}">
  <cv-photo-card
    *ngIf="selectedSchema && items.length"
    class="cv-photo-review-container__card-component"
    [photos]="items"
    [SchemaType]="selectedSchema"
    [cardType]="photoReviewUiState.TAB_TITLES.ALL"
  ></cv-photo-card>
</div>